import $ from "jquery";
import * as FilePond from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginMediaPreview from 'filepond-plugin-media-preview';
// Import the plugin styles
import "filepond/dist/filepond.css";
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-media-preview/dist/filepond-plugin-media-preview.css';
FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginFileValidateSize);
FilePond.registerPlugin(FilePondPluginMediaPreview);
$(document).ready(function () {
    if ($('.filepond').length) {
        $('.filepond').each(function (i, e) {
            var that = e;
            // var dataId = $(that).data("column");
            var loadUrl = $(that).data("load");
            var deleteUrl = $(that).data("delete");
            var sendUrl = $(that).data("send");
            // var folder = $(that).data("folder");
            var maxFileSize = $(that).data("file-size");
            var acceptedType = $(that).data("accept").split(",");
            // var isMutiple = $(that).data("multiple") == "multiple" ? true : false;
            var options = {
                files: [],
                // allowMultiple: isMutiple,
                maxFileSize: maxFileSize,
                allowFileTypeValidation: acceptedType,
                beforeRemoveFile: function (item) {
                    // console.log(item);
                    if (confirm("Are you sure to remove this file?")) {
                        $.post(deleteUrl, { link: item.serverId }, function () {
                            swal("Your file has been deleted!", {
                                icon: "success"
                            });
                        });
                        return true;
                    }
                    // swal({
                    //     title: "",
                    //     text: "Once deleted, you will not be able to recover this imaginary file!",
                    //     icon: "warning",
                    //     buttons: true,
                    //     dangerMode: true,
                    //   }).then((willDelete) => {
                    //     if (willDelete) {
                    //         $.post(deleteUrl, { link: item.serverId }, () => {
                    //             deleted = true;
                    //             swal("Poof! Your imaginary file has been deleted!", {
                    //                 icon: "success",
                    //             });
                    //         });
                    //     } else {
                    //         deleted = false;
                    //     }
                    //   });
                    return false;
                },
                server: {
                    process: {
                        url: sendUrl,
                        onload: function (r) {
                            var resp = (JSON.parse(r));
                            if (resp.link !== void 0) {
                                // $("#"+dataId).val(resp.link);
                            }
                        }
                    },
                    load: function (source, load, error, progress, abort, headers) {
                        var myRequest = new Request(source);
                        fetch(myRequest).then(function (response) {
                            response.blob().then(function (myBlob) {
                                load(myBlob);
                            });
                        });
                    }
                }
            };
            $.getJSON(loadUrl, function (data) {
                options.files = data;
                var pond = FilePond.create($(that).get(0), options);
                // var pond = $(that).filepond(options);
            });
        });
    }
});
